<div class="outlet-container">
  <router-outlet></router-outlet>
</div>
